export const ENV = (process.env.REACT_APP_ENV ??
  process.env.NODE_ENV ??
  'production') as 'production' | 'development'

export const APP_HEADER_HEIGHT = 70
export const COMPANY_NAME = 'SK UNIC'
